/* eslint-disable key-spacing */
<template>
  <div class="museumWelpage">
    <img class="cloud-left" src="../assets/museum/cloud-left.png" alt="">
    <img class="cloud-rightbottom" src="../assets/museum/cloud-rightbottom.png" alt="">
    <img class="cloud-righttop" src="../assets/museum/cloud-righttop.png" alt="">
    <img class="shuiyin" src="../assets/museum/shuiyin.png" alt="">
    <img class="logo" src="../assets/museum/logo.png" alt="">
    <img class="title" src="../assets/museum/title.png" alt="">
    <img class="tip" src="../assets/museum/tip.png" alt="">
    <img class="btn" src="../assets/museum/btn.png" alt="" @click="hidePage">
  </div>
</template>

<script>
export default {
  name: 'xuexiqiangguo',
  data () {
    return {}
  },
  mounted () {
  },
  methods: {
    hidePage () {
      window.location.href = 'http://virtual.vizen.cn/exhibitionh5/index.html'
    }
  }
}
</script>

<style lang="scss">
  @function rem($px) {
    @return $px*(1/25)*1rem;
  }
  @keyframes myanimation {
    0%   {transform: scale(1);}
    25%  {transform: scale(1.1);}
    50%  {transform: scale(1);}
    100% {transform: scale(0.9);}
  }
  $animationTime: 0.6s;

  .museumWelpage{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: linear-gradient(180deg, #FFFFFF 0%, #FEF4E2 100%);
    z-index: 1;
    &.cover-leave-to {
      opacity: 0;
    }
    &.cover-leave-active {
      transition: opacity $animationTime;
    }
    .cloud-left{
      width: rem(193);
      height: rem(87);
      position: absolute;
      left: 0;
      top: rem(180);
    }
    .cloud-rightbottom{
      width: rem(340);
      height: rem(105);
      position: absolute;
      right: 0;
      bottom: 0;
    }
    .cloud-righttop{
      width: rem(151);
      height: rem(88);
      position: absolute;
      right: 0;
      top: rem(50);
    }
    .shuiyin{
      width: rem(257);
      height: rem(272);
      position: absolute;
      left: 0;
      top: rem(180);
    }
    .logo{
      width: rem(200);
      height: rem(35);
      position: absolute;
      left: 50%;
      top: rem(20);
      transform: translateX(-50%);
    }
    .title{
      width: rem(110);
      height: rem(280);
      position: absolute;
      left: 50%;
      top: rem(98);
      transform: translateX(-50%);
    }
    .tip{
      width: rem(140);
      height: rem(35);
      position: absolute;
      left: 50%;
      top: rem(420);
      transform: translateX(-50%);
    }
    .btn{
      width: rem(129);
      height: rem(40);
      position: absolute;
      left: 50%;
      bottom: rem(85);
      transform: translateX(-50%);
    }
  }
</style>
